/* eslint-disable */
import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { MSRemoteLoggerCategory, MSRemoteLoggerData } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';
import { ApiServiceOld } from './api-old.service';
import { CONSTANTS } from './config.service';
import { DailySurveyService } from './daily-survey.service';
import { DateTimeService } from './date-time/date-time.service';
import { GeowatcherService } from './geowatcher.service';
import { LoggerService } from './logger.service';
import { PrefsService } from './prefs.service';
import { ProxySurveyService } from './proxy-survey.service';
import { PubSubService } from './pub-sub.service';
import { SignupSurveyService } from './signup-survey.service';
import { SqlHelperService } from './sql-helper.service';
import { TripSurveyService } from './trip-survey.service';

@Injectable({
  providedIn: 'root'
})
export class SenderSurveyService {
  TYPE_TRIP = 0;
  TYPE_DAILY = 1;
  TYPE_PROXY = 2;
  db;
  table = CONSTANTS.queueTableName;
  initialized = false;
  serverActivationCode;
  appVersion;
  logFailure = this.logger.makeFailureLogger('in heterogeneous sender');
  surveyFinishedUnsubscriber;
  tripEndedUnsubscriber;
  intervalPromise;
  sending: boolean;
  createTableSql =
    'CREATE TABLE IF NOT EXISTS ' +
    this.table +
    '(' +
    'id INTEGER PRIMARY KEY AUTOINCREMENT, ' +
    'type INTEGER NOT NULL, ' +
    'subjectId INTEGER, ' +
    'UNIQUE (type, subjectId) ON CONFLICT IGNORE' +
    ');';

  constructor(
    private platform: Platform,
    private logger: LoggerService,
    private dateTime: DateTimeService,
    private prefs: PrefsService,
    private geowatcher: GeowatcherService,
    private pubSub: PubSubService,
    private api: ApiServiceOld,
    private sqlHelper: SqlHelperService,
    private signupSurvey: SignupSurveyService,
    private tripSurvey: TripSurveyService,
    private dailySurvey: DailySurveyService,
    private proxySurvey: ProxySurveyService
  ) {
    this.platform.ready().then(() => {
      this.logger.log('Sender survey constructor - initing db and subscribing to tripEnded and surveyFinished events', MSRemoteLoggerCategory.SENDER_SURVEY_SERVICE);
      this.initializeDb();

      this.pubSub.subscribe(CONSTANTS.EVENTS.tripEnded, (...args) => {
        this.logger.log('Subscribed to tripEnded event in sender-survey', MSRemoteLoggerCategory.SENDER_SURVEY_SERVICE);
        this.queueThenSend();
      });
      this.pubSub.subscribe(CONSTANTS.EVENTS.surveyFinished, (...args) => {
        this.logger.log('Subscribed to surveyFinished event in sender-survey', MSRemoteLoggerCategory.SENDER_SURVEY_SERVICE);
        this.queueAll();
      });
    });
  }

  getFieldMapper(keyMap, ignoredKeys) {
    const self = this;
    return function (subject) {
      const data = { activationCode: self.serverActivationCode, appVersion: self.appVersion };

      Object.keys(subject).forEach((key) => {
        let cbKeyValuePair;
        let cbKey;
        let cbValue;
        const value = subject[key];

        if (value !== null && ignoredKeys.indexOf(key) === -1) {
          key = keyMap.hasOwnProperty(key) ? keyMap[key] : key;
          // HACK_CB
          //   maps {_CB_mode_43: 1, _CB_mode_56: 1} to mode=[43, 56]
          if (key.startsWith('_CB_')) {
            if (value) {
              // TODO use regex instead, throw for no match
              cbKeyValuePair = key.substring('_CB_'.length).split('_');
              cbKey = cbKeyValuePair[0];
              cbValue = cbKeyValuePair[1];
              if (!data[cbKey]) {
                data[cbKey] = [];
              }
              data[cbKey].push(cbValue);
            }
          } else if (
            value == CONSTANTS.YEAR_MAKE_MODEL_OTHER &&
            (key.includes('_year_') || key.includes('_make_') || key.includes('_model_'))
          ) {
            // skip - for app-only
          } else {
            data[key] = value;
          }
        }
      });
      return data;
    };
  }

  post(path, requestData) {
    return new Promise((resolve, reject) => {
      this.api.post(path, requestData).subscribe(
        (res) => {
          this.logger.log('Resolved posting to', MSRemoteLoggerCategory.SENDER_SURVEY_SERVICE, path, res as MSRemoteLoggerData);
          if (requestData.expectsData) {
            resolve(res);
          } else if (res === 'ok' || res === 'unk') {
            // TODO unk is for unknown activation code - not resending this responseData for now
            resolve(res);
            // service providers can hijack requests - e.g. by returning status 200 with an 'Inactive Account' page
          } else {
            reject('Error posting survey');
          }
        },
        (err) => {
          // HACK
          // angular assumes response is json, but it's just text
          // TODO this assumes it's our server responding (not a service provider 'Inactive Account' page),
          //      didn't want to change this near release because comparing nested errors seemed fragile
          // if (err.status === 200 && err.error && err.error.error && err.error.error.message === 'JSON Parse error: Unexpected identifier "ok"') {
          if (err.status === 200) {
            resolve('Success posting');
          } else {
            this.logger.log('Error posting to', MSRemoteLoggerCategory.SENDER_SURVEY_SERVICE, path, err.status, err.message);
            reject(err);
          }
        }
      );
    });
  }

  uploadTripSurvey(tripSurveyId, scope) {
    const fieldMapper = scope.getFieldMapper(
      {
        clonedId: 'deviceClonedSurveyId',
        id: 'deviceSurveyId',
        subjectPersonId: 'subjectPersonIdx',
        takerPersonId: 'takerPersonIdx',
        deleteFlag: 'delete'
      },
      ['queued', 'hideFromUi', 'verified']
    );

    return scope.sqlHelper
      .getSelectPromise(scope.db, CONSTANTS.tripSurveyTableName, ['*'], { id: tripSurveyId })
      .then((surveys) => scope.post('/upload_trip_survey', fieldMapper(surveys[0])));
  }

  uploadDailySurvey(dailySurveyId, scope) {
    const fieldMapper = scope.getFieldMapper(
      {
        id: 'deviceSurveyId',
        subjectPersonId: 'subjectPersonIdx',
        takerPersonId: 'takerPersonIdx',
        deleteFlag: 'delete'
      },
      ['queued', 'hideFromUi']
    );

    return scope.sqlHelper
      .getSelectPromise(scope.db, CONSTANTS.dailySurveyTableName, ['*'], { id: dailySurveyId })
      .then((surveys) => scope.post('/upload_daily_survey', fieldMapper(surveys[0])));
  }

  uploadProxySurvey(proxySurveyId, scope) {
    const fieldMapper = scope.getFieldMapper(
      {
        id: 'deviceSurveyId',
        subjectPersonId: 'subjectPersonIdx',
        takerPersonId: 'takerPersonIdx',
        deleteFlag: 'delete'
      },
      ['queued', 'hideFromUi']
    );

    return scope.sqlHelper
      .getSelectPromise(scope.db, CONSTANTS.proxySurveyTableName, ['*'], { id: proxySurveyId })
      .then((surveys) => scope.post('/upload_proxy_survey', fieldMapper(surveys[0])));
  }

  uploadSignupSurvey(isPartialSurvey) {
    const targetUrl = isPartialSurvey ? '/upload_partial_signup' : '/activate_household';
    const fieldMapper = this.getFieldMapper(
      {
        id: 'deviceSurveyId'
      },
      []
    );

    return Promise.all([
      this.sqlHelper.getSelectPromise(this.db, CONSTANTS.signupSurveyTableName, ['*'], {}),
      this.prefs.getPromises('authCode', 'locale')
    ])
      .then((results) => {
        const surveys = JSON.parse(JSON.stringify(results[0])); // typescript didn't see this as an array so hacking it a bit
        const authCode = results[1][0];
        const locale = results[1][1];
        let requestData;

        if (surveys.length === 0) {
          throw 'no hh survey to upload';
        }
        requestData = Object.assign({}, fieldMapper(surveys[0]), {
          authCode,
          expectsData: true,
          locale,
          isWeb: CONSTANTS.IS_DEVICE == false ? 1 : 0
        });
        return this.post(targetUrl, requestData);
      })
      .then((res: any) => {
        if (!isPartialSurvey && res.abortMessageKey === undefined) {
          this.signupSurvey.markSent();
        }
        return res;
      });
  }

  sendAllAndroid() {
    this.geowatcher.sendSurveys();
  }

  sendAllGeneric() {
    const self = this;

    if (this.sending) {
      this.logger.log('Sender survey already sending', MSRemoteLoggerCategory.SENDER_SURVEY_SERVICE);
      return Promise.resolve();
    }

    if (!this.initialized) {
      this.logger.warn('Attempted sender survey send before initialized', MSRemoteLoggerCategory.SENDER_SURVEY_SERVICE);
      return Promise.resolve();
    }

    this.sending = true;

    return this.sqlHelper
      .getSelectPromise(this.db, this.table, ['*'], {}, 'id ASC')
      .then((rows: any[]) => {
        const uploadFns = [self.uploadTripSurvey, self.uploadDailySurvey, self.uploadProxySurvey];
        const promises = [];

        rows.forEach((row) => {
          const uploadFn = uploadFns[row.type];

          promises.push(uploadFn(row.subjectId, self).then((res) => self.sqlHelper.getDeletePromise(self.db, self.table, { id: row.id })));
        });

        return Promise.all(promises);
      })
      .catch((err) => {
        this.logger.makeFailureLogger(err);
      })
      .then(() => {
        this.sending = false;
      });
  }

  queueAllGeneric() {
    const self = this;
    const queue = function (surveyService, type) {
      return surveyService.getUnqueuedIds().then((surveys) => {
        const promises = [];
        surveys.forEach((survey) => {
          const id = survey.id;
          promises.push(
            self.sqlHelper.getInsertPromise(self.db, self.table, { subjectId: id, type }).then(() => surveyService.markQueued(id))
          );
        });
        return Promise.all(promises);
      });
    };

    return Promise.all([
      queue(this.tripSurvey, this.TYPE_TRIP),
      queue(this.dailySurvey, this.TYPE_DAILY),
      queue(this.proxySurvey, this.TYPE_PROXY)
    ]);
  }

  queueAllAndroid() {
    const self = this;
    const queue = function (surveyService, type) {
      return surveyService.getUnqueuedIds().then((surveys) => {
        const promises = [];

        surveys.forEach((survey) => {
          const id = survey.id;

          if (type === self.TYPE_TRIP) {
            promises.push(self.geowatcher.queueSurveyForSending(id).then(() => surveyService.markQueued(id)));
          } else if (type === self.TYPE_DAILY) {
            promises.push(self.geowatcher.queueDailySurveyForSending(id).then(() => surveyService.markQueued(id)));
          } else if (type === self.TYPE_PROXY) {
            promises.push(self.geowatcher.queueProxySurveyForSending(id).then(() => surveyService.markQueued(id)));
          }
        });
        return Promise.all(promises);
      });
    };
    return Promise.all([
      queue(this.tripSurvey, this.TYPE_TRIP),
      queue(this.dailySurvey, this.TYPE_DAILY),
      queue(this.proxySurvey, this.TYPE_PROXY)
    ]);
  }

  queueAll() {
    // only use android if on device as well
    if (this.platform.is('android') && CONSTANTS.IS_DEVICE) {
      return this.queueAllAndroid();
    } else {
      return this.queueAllGeneric();
    }
  }

  queueThenSend() {
    if (this.platform.is('android') && CONSTANTS.IS_DEVICE) {
      this.queueAllAndroid().then(() => {
        this.sendAllAndroid();
      });
    } else {
      this.queueAllGeneric().then(() => {
        this.sendAllGeneric();
      });
    }
  }

  hasUnsent() {
    return this.sqlHelper.getExistsPromise(this.db, this.table, { id_NOTNULL: null });
  }

  //   stop: function () {
  //       if (intervalPromise) {
  //           $interval.cancel(intervalPromise);
  //       }
  //       pubSub.unsubscribe(surveyFinishedUnsubscriber);
  //       pubSub.unsubscribe(tripEndedUnsubscriber);
  //   }

  initialize() {
    return this.prefs
      .getPromises('activationCode', 'appVersion')
      .then((results) => {
        this.serverActivationCode = results[0];
        this.appVersion = results[1];
        return this.sqlHelper.createTablePromise(this.db, this.createTableSql);
      })
      .then(() => {
        this.intervalPromise = setInterval(
          () => {
            this.logger.log('Sender survey interval triggered. Queueing and sending.', MSRemoteLoggerCategory.SENDER_SURVEY_SERVICE);
            this.queueThenSend();
          },
          this.dateTime.getMilliseconds(8, 0, 0)
        );

        // TODO - unsubs
        // this.tripEndedUnsubscriber =      this.pubSub.subscribe(CONSTANTS.EVENTS.tripEnded, function () { self.queueThenSend() });
        // this.surveyFinishedUnsubscriber = this.pubSub.subscribe(CONSTANTS.EVENTS.surveyFinished, function () { self.queueAll() }); // not sending immediately - slowed UI
        this.initialized = true;
        return Promise.resolve();
      })
      .catch((err) => Promise.reject(err));
  }

  // need to init db for sending partial signup surveys. can't wait until initializer inits the db
  initializeDb() {
    return this.sqlHelper
      .createDb({ name: CONSTANTS.mainFrontEndDbName, location: 'default', androidDatabaseProvider: 'system', androidLockWorkaround: 1 })
      .then((db) => {
        this.db = db;
      })
      .catch((err) => {
        this.logger.error('Error initializing sender survey provider.', MSRemoteLoggerCategory.SENDER_SURVEY_SERVICE, err);
      });
  }
}
